import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-stepper', {
    month: {
        1: 'month',
        2: 'months',
    },
    year: {
        1: 'year',
        2: 'years',
    },
    increase: 'Increase',
    decrease: 'Decrease',
    value: 'Value',
    max: 'Maximum',
    min: 'Minimum',
});
